/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import OutboundWebhookInserterConfiguration from 'embercom/objects/series/node/outbound-webhook-inserter-configuration';

export default class OutboundWebhookNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new OutboundWebhookInserterConfiguration();
  category = NODE_CATEGORIES.action;
}
